export const HREF_LINKS = ["tel:", "mailto:"];
export const HREF_INACTIVE = "javascript:void(0);";
